<template>
  <v-container>
    <v-form autocomplete="off">
      <div class="d-flex justify-space-between">
        <div
          class="flex-column flex-fill mr-15 align-self-start"
          style="width: 50%"
        >
          <v-list-item>
            <v-list-item-content>
              <Label label="所有会社" :editable="editable" required>
                <SelectWithFilter
                  pinId="selectMachineSiteFormPage11"
                  name="company_id"
                  :values="formValues"
                  :items="COMPANY_ITEM"
                  :editable="editable && !disableSelectCompany"
                  validation_label="所有会社"
                  validation_rules="required"
                  :autofocus="autofocus"
                  @onInput="onInput"
                />
              </Label>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <Label
                :label="editable ? '種別（機械名）' : '機械名'"
                :editable="editable"
                required
              >
                <div class="d-flex flex-space-between">
                  <v-btn
                    v-if="editable"
                    class="mr-5"
                    color="primary"
                    @click="onClickSearch"
                  >
                    機械選択
                  </v-btn>
                  <InputText
                    :class="editable ? 'flex-grow-1 ml-5' : 'flex-grow-1'"
                    name="middle_classification"
                    :values="formValues"
                    :readonly="true"
                    :editable="editable"
                    validation_label="種別（機械名）"
                    validation_rules="required"
                  />
                </div>
              </Label>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <Label label="仕様・能力" :editable="editable" required>
                <InputText
                  name="machine_name"
                  :values="formValues"
                  :editable="editable"
                  validation_label="仕様・能力"
                  validation_rules="required"
                  @onInput="onInput"
                />
              </Label>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="formValues['middle_classification_id']">
            <v-list-item-content>
              <Label label="機械画像">
                <v-btn v-show="editable" color="primary">
                  <label for="formFileLg">ファイルを選択</label>
                  <input
                    class="d-none"
                    type="file"
                    accept="image/gif, image/jpeg, image/png"
                    ref="fileInput"
                    id="formFileLg"
                    @input="selectImgFile"
                  />
                </v-btn>
                <v-img
                  contain
                  :src="url_image_device"
                  max-width="600px"
                  max-height="600px"
                />
              </Label>
            </v-list-item-content>
          </v-list-item>
        </div>
        <div
          class="flex-column flex-fill ml-15 align-self-start"
          style="width: 50%"
        >
          <v-list-item>
            <v-list-item-content>
              <Label label="管理区分" :editable="editable" required>
                <RadioGroup
                  v-if="editable"
                  name="type"
                  :values="formValues"
                  :items="MACHINE_FIELDS_TYPE_STATUS"
                  :editable="isNewItem"
                  validation_label="管理区分"
                  validation_rules="required"
                  @onInput="onInput"
                />
                <span v-if="!editable">
                  {{
                    getRadioName(MACHINE_FIELDS_TYPE_STATUS, formValues["type"])
                  }}</span
                >
              </Label>
            </v-list-item-content>
          </v-list-item>
          <MachineFieldsInput
            :isShowInput="this.isShowInput"
            :isDisabled="this.isDisabled"
            name="machine_fields"
            :values="formValues"
            :editable="editable"
            :acceptant_number="acceptant_number"
            :isNewItem="isNewItem"
            :management="formValues.type"
            @onInput="onInput"
          />
          <v-list-item v-if="!this.isShowInput && this.type != 2">
            <v-list-item-content>
              <div class="d-flex flex-space-between">
                <Label
                  label="数量"
                  :editable="editable"
                  required
                  style="width: 50%"
                >
                  <InputText
                    name="quantity"
                    :values="formValues"
                    :editable="formValues.type == 0 ? false : editable"
                    suffix="個"
                    validation_label="数量"
                    validation_rules="required|digit"
                    @onInput="onInput"
                  />
                </Label>
                <Label label=""></Label>
              </div>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
      <Popup width="500px" :dialog="isShowSearchDialog">
        <SearchMachineDialog
          title="機械選択"
          :formValues="machineValues"
          @formMachineUpdate="formMachineUpdate"
          @onSearch="searchMachine"
          @close="closeSearchMachineForm"
        />
      </Popup> </v-form
  ></v-container>
</template>
<script>
import { Store } from "@/store/Store.js";
import _ from "lodash";
import {
  MACHINE_FIELDS_TYPE_STATUS,
  MACHINE_SITE_CATEGORY,
} from "@/constants/MACHINE_SITES";
import { COMPANY_TYPE } from "@/constants/COMMON";

import Label from "@/components/forms/elements/Label";
import InputText from "@/components/forms/elements/InputText";
import SelectWithFilter from "@/components/forms/elements/SelectWithFilter.vue";
import RadioGroup from "@/components/forms/elements/RadioGroup.vue";
import MachineFieldsInput from "./components/MachineFieldsInput.vue";
import Popup from "@/components/common/Popup.vue";
import SearchMachineDialog from "@/components/dialog/SearchMachineDialog.vue";

export default {
  components: {
    Label,
    InputText,
    SelectWithFilter,
    RadioGroup,
    MachineFieldsInput,
    Popup,
    SearchMachineDialog,
  },
  data: () => {
    return {
      formValues: {
        type: 0,
        quantity: "1",
      },
      MACHINE_FIELDS_TYPE_STATUS,
      MACHINE_SITE_CATEGORY,
      sequence_number: "",
      MACHINE_ITEM: [],
      COMPANY_ITEM: [],
      autofocus: false,
      url_image_device: "",
      fileBase64: null,
      fileName: null,
      isShowSearchDialog: false,
      machineValues: {
        items: [],
        keyword: "",
        selected: null,
        major_id: null,
      },
      acceptant_number: "",
      isShowInput: false,
      isDisabled: true,
      type: null,
    };
  },
  props: {
    item: Object,
    editable: {
      type: Boolean,
      default: false,
    },
    formUpdate: Function,
    isNewItem: Boolean,
  },
  async mounted() {
    this.getListCompany();
    this.getDataCompany();
    this.$watch(
      () => this.item,
      (newValue) => {
        this.formValues = { ...newValue };
        if (!this.isNewItem) {
          let _quantity = this.formValues.quantity;
          if (_quantity) this.formValues.quantity = _quantity.toString();
          let machine_fields = [];
          let machine_field_element = {};
          machine_field_element.acceptant_number =
            this.formValues.acceptant_number;
          machine_field_element.machine_number = this.formValues.machine_number;
          machine_field_element.machine_field_name =
            this.formValues.machine_field_name;
          machine_field_element.serial_number = this.formValues.serial_number;
          machine_field_element.inspector = this.formValues.inspector;
          machine_field_element.company_inspector =
            this.formValues.company_inspector;
          machine_field_element.remarks = this.formValues.remarks;
          machine_field_element.quantity = _quantity;
          machine_field_element.machine_field_name_prefix =
            this.formValues.machine_field_name_prefix;
          machine_fields.push(machine_field_element);
          this.type = this.formValues.type;
          this.formValues.machine_fields = _.cloneDeep(machine_fields);
        }
        // set value default for 所有会社 if company is partner or rental
        if (
          this.isNewItem &&
          (this.loginUser.company_type === COMPANY_TYPE.PARTNER ||
            this.loginUser.company_type === COMPANY_TYPE.RENTAL)
        ) {
          this.formValues["company_id"] = this.loginUser.company_id;
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    this.$watch(
      () => this.editable,
      (flag) => {
        if (!flag) {
          this.getDetail();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    this.$watch(
      () => this.editable,
      (newValue) => {
        this.autofocus = newValue;
        if (newValue && !this.isNewItem) {
          const companyNameElement = document.getElementsByTagName("input");
          companyNameElement[6].focus();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    this.$watch(
      () => Store.getters["CmnMst/getListMediumInspection"],
      (data) => {
        this.machineValues.items = [...data];
      },
      {
        deep: true,
      }
    );
  },

  computed: {
    currentSite() {
      return Store.state.GlobalHeader.selectedSite;
    },

    loginUser() {
      return Store.state.Login.user;
    },

    disableSelectCompany() {
      let companyType = this.loginUser?.company_type;
      if (
        companyType === COMPANY_TYPE.PARTNER ||
        companyType === COMPANY_TYPE.RENTAL
      )
        return true;
      else return false;
    },
  },
  methods: {
    async getListCompany() {
      if (!this.currentSite.field_id) return;
      let fieldApiParams = {
        field_id: this.currentSite.field_id,
      };
      const fieldUserList = await Store.dispatch(
        `FieldUser/get`,
        fieldApiParams
      );
      const { entries } = fieldUserList.data.contents;
      let listIds = [];
      if (!fieldUserList.hasError) {
        listIds = [...new Set(entries.map((entry) => entry.company_id))];
      }
      let apiParams = { company_type: [COMPANY_TYPE.RENTAL] };
      const rentalCompanyList = await Store.dispatch(`Company/get`, apiParams);
      if (!rentalCompanyList.hasError) {
        const { entries } = rentalCompanyList.data.contents;
        let ids = [];
        ids.push(...listIds);
        ids.push(...entries.map((item) => item.id));
        const companyList = await Store.dispatch(`Company/getCompanyByIds`, {
          ids,
        });
        if (!companyList.hasError) {
          const { entries } = companyList.data.contents;
          this.COMPANY_ITEM = [...entries];
          if (this.loginUser.company_type === COMPANY_TYPE.PARTNER) {
            this.COMPANY_ITEM = this.COMPANY_ITEM.filter(
              (item) => item.id === this.loginUser.company_id
            );
          }
          this.COMPANY_ITEM.unshift({
            id: null,
            name: "",
          });
        }
      }
    },
    async getDetail() {
      if (
        this.formValues["major_classification_id"] &&
        this.formValues["middle_classification_id"]
      ) {
        this.getImageDevice(
          this.formValues["major_classification_id"],
          this.formValues["middle_classification_id"]
        );
      }
      let _formValue = { ...this.formValues };
      this.$emit("formUpdate", _formValue);
    },
    async onInput({ name, value }) {
      const formValues = { ...this.formValues };
      if (name == MACHINE_SITE_CATEGORY.MACHINE_ID) {
        formValues["machine_field_inspections"] = [];
      }
      let custommize_field_inspections =
        formValues.machine_field_inspections.filter((e) => e.modified_flg == 1);
      if (name == MACHINE_SITE_CATEGORY.TYPE) {
        if (value == 0) {
          formValues.quantity = "1";
          this.isShowInput = false;
          this.isDisabled = true;
          this.$emit("showButton");
        } else if (value == 1) {
          formValues.quantity = null;
          let machine_fields = [...formValues.machine_fields];
          let rs = [];
          rs.push(machine_fields[0]);
          formValues.machine_fields = [...rs];
          this.isShowInput = false;
          this.isDisabled = true;
          this.$emit("showButton");
        } else if (value == 2) {
          formValues.quantity = null;
          let machine_fields = [...formValues.machine_fields];
          let rs = [];
          rs.push(machine_fields[0]);
          formValues.machine_fields = [...rs];
          this.isShowInput = true;
          this.isDisabled = false;
          this.$emit("hiddenButton");
        }
      }
      if (name == MACHINE_SITE_CATEGORY.MACHINE_FIELDS && !this.isNewItem) {
        let _machine_field = value[0];
        formValues.machine_field_name = _machine_field.machine_field_name;
        formValues.machine_number = _machine_field.machine_number;
        formValues.serial_number = _machine_field.serial_number;
        formValues.inspector = _machine_field.inspector;
        formValues.remarks = _machine_field.remarks;
        formValues.company_inspector = _machine_field.company_inspector;
      }
      if (name == MACHINE_SITE_CATEGORY.QUANTITY) {
        if (parseInt(value) < 1) {
          value = null;
        }
      }
      if (name == MACHINE_SITE_CATEGORY.COMPANY_ID) {
        if (!this.isNewItem) {
          this.findCompanyPrefix(value);
        }
      }
      if (name == MACHINE_SITE_CATEGORY.MACHINE_ID) {
        formValues["machine_field_inspections"] =
          await this.getListMachineFieldInspectionsByMachineId(value, [
            ...custommize_field_inspections,
          ]);
        formValues.major_classification_id = this.MACHINE_ITEM.find(
          (item) => item.id == value
        )?.major_classification_id;
        formValues.middle_classification_id = this.MACHINE_ITEM.find(
          (item) => item.id == value
        )?.middle_classification_id;
        let rs =
          formValues.major_classification_id &&
          formValues.middle_classification_id;
        if (!rs) {
          this.getImageDevice(
            formValues.major_classification_id,
            formValues.middle_classification_id
          );
        }
      }
      formValues[name] = value;
      this.formValues = formValues;
      this.$emit("formUpdate", formValues);
    },
    //get radio name
    getRadioName(items, value) {
      return items.find((item) => item.value == value)?.name;
    },

    async getListMachineFieldInspectionsByMachineId(
      id,
      custommize_field_inspections
    ) {
      let rs = [];
      const response = await Store.dispatch(`Machines/getMachineDetail`, id);
      if (!response.hasError) {
        rs = [...response.data.contents.entries.machine_inspection_items];
        custommize_field_inspections.forEach((e) => {
          rs.push(e);
        });
      }
      return rs;
    },
    async getImageDevice(major_id, middle_id) {
      let image_url = "";
      let params = {
        main_contractor_id: this.currentSite.main_contractor_id,
        major_classification_id: major_id,
        middle_classification_id: middle_id,
        field_id: this.currentSite.field_id,
        machine_field_id: this.formValues.id,
      };
      if (this.isNewItem) {
        const response1 = await Store.dispatch(`CmnMst/getImageDevice`, {
          params,
        });
        image_url = response1.data.contents.entries.image_url;
      } else if (major_id && middle_id) {
        const response = await Store.dispatch(
          `MachineSites/getMachineFieldImage`,
          {
            params,
          }
        );
        if (!response.hasError) {
          image_url = response.data.contents.entries?.image_url;
          if (image_url == null || image_url == "") {
            const response1 = await Store.dispatch(`CmnMst/getImageDevice`, {
              params,
            });
            image_url = response1.data.contents.entries.image_url;
          }
        }
      }
      let be_url = process.env.VUE_APP_API_BASE_URL.replace("/api", "");
      const imageUrl = `${
        be_url + image_url
      }?timestamp=${new Date().getTime()}`;
      this.url_image_device = imageUrl;
    },
    async getDefaultInspections(major_id, middle_id) {
      let params = {
        main_contractor_id: this.currentSite.main_contractor_id,
        major_classification_id: major_id,
        middle_classification_id: middle_id,
      };
      let result = {};
      if (major_id && middle_id) {
        const response = await Store.dispatch(`CmnMst/getListInspections`, {
          params,
        });
        if (!response.hasError) {
          let monthly = [...response.data.contents.entries.monthly];
          let daily = [...response.data.contents.entries.daily];
          result = [...monthly, ...daily];
        }
      }
      return result;
    },
    async getDataCompany() {
      await Store.dispatch(`Company/getListCompaniesHasMachine`);
    },
    async onClickSearch() {
      await Store.dispatch("CmnMst/getListMediumInspection", {
        main_contractor_id: this.currentSite.main_contractor_id,
        field_id: this.currentSite.field_id,
      });
      this.isShowSearchDialog = true;
    },
    async searchMachine() {
      let keyword = this.machineValues.keyword;
      await Store.dispatch("CmnMst/getListMediumInspection", {
        middle_classification: keyword,
        main_contractor_id: this.currentSite.main_contractor_id,
        field_id: this.currentSite.field_id,
      });
    },
    async formMachineUpdate(values) {
      this.machineValues = { ...values };
      if (this.machineValues.selected) {
        this.isShowSearchDialog = false;
        const formValues = { ...this.formValues };
        if (this.machineValues.major_id && this.machineValues.selected) {
          formValues.major_classification_id = this.machineValues.major_id;
          formValues.middle_classification_id = this.machineValues.selected;
          formValues.middle_classification =
            this.machineValues.middle_classification;
          await this.getImageDevice(
            formValues["major_classification_id"],
            formValues["middle_classification_id"]
          );
          formValues["machine_field_inspections"] =
            await this.getDefaultInspections(
              formValues["major_classification_id"],
              formValues["middle_classification_id"]
            );
        } else {
          formValues.major_classification_id = null;
          formValues.middle_classification_id = null;
          this.url_image_device = "";
        }
        formValues.machine_id = null;
        this.formValues = formValues;
        const machineValues = {
          items: [],
          middle_classification: "",
          selected: null,
          major_id: null,
        };
        this.machineValues = { ...machineValues };
        this.$emit("formUpdate", formValues);
      }
    },
    closeSearchMachineForm() {
      this.isShowSearchDialog = false;
      const machineValues = {
        items: [],
        middle_classification: "",
        selected: null,
        major_id: null,
      };
      this.machineValues = machineValues;
    },
    findCompanyPrefix(company_id) {
      const arr = [...this.COMPANY_ITEM];
      let company_prefix = "";
      const dataFind = arr.find((item) => item.id == company_id);
      if (dataFind) {
        company_prefix = dataFind.company_prefix ? dataFind.company_prefix : "";
      }
      this.acceptant_number = `${company_prefix}${this.formValues.acceptant_number}`;
    },
    selectImgFile() {
      let fileInput = this.$refs.fileInput;
      let imgFile = fileInput.files;
      this.fileName = imgFile[0]["name"];
      let isVai = this.validate(imgFile[0]);
      if (imgFile && imgFile[0] && isVai) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.fileBase64 = e.target.result;
          this.url_image_device = e.target.result;
          const formValues = { ...this.formValues };
          formValues["image"] = this.fileBase64;
          formValues["image_name"] = this.fileName;
          this.$emit("formUpdate", formValues);
        };
        reader.readAsDataURL(imgFile[0]);
      }
    },
    validate(file) {
      let _10m = 10000000;
      const TYPE_FILE = {
        gif: "image/gif",
        jpeg: "image/jpeg",
        png: "image/png",
      };
      if (
        file.type === TYPE_FILE.gif ||
        file.type === TYPE_FILE.jpeg ||
        file.type === TYPE_FILE.png
      ) {
        this.enable = false;
      } else {
        Store.dispatch(
          "Error/show",
          {
            status: "500",
            message: "jpg, png, jpegファイルのみアップロード可能です",
          },
          { root: true }
        );
        return false;
      }
      if (file.size > _10m) {
        this.enable = true;
        this.urlFile = null;
        Store.dispatch(
          "Error/show",
          { status: "500", message: "データ容量は10MB以下でお願いします" },
          { root: true }
        );
        return false;
      } else {
        this.enable = false;
      }
      return true;
    },
  },
};
</script>
